'use client';
import style from '@/app/style/servicesetyle.module.css';
import Button from '@/app/btn/page';
import Mydata from '@/app/data/Servies/car_service.json';

const ctabanner = ({ Mydata }) => {
  const data = Mydata?.[3];
  console.log(data, 'ctaaaaaaaaaaaaaaaaaaaa');
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div>
      <div className="">
        {/* <div> */}
        <div className={style[data?.iamge]}>
          <div className="mx-auto max-w-7xl grid grid-cols-2 flex items-center px-6 lg:pt-10">
            <div>
              <h2 id="visionh2" className="text-4xl text-white  font-bold">
                <span>{data?.subtitle}</span> <span>{data?.title}</span>
              </h2>
              <div className="updatedparapremu text-white pt-3 mb-3">
                {data?.des}
              </div>

              <button
                onClick={scrollTop}
                className="bg-b pr-4 pl-4 mb-7 pt-2 pb-2 rounded-md mt-3"
              >
                BOOK NOW
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ctabanner;
